import React, { useState } from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import Summary from "./Summary";
import Breadcrumbs from "../../components/ui/Breadcrumbs";
import { RootState } from "../../services/redux/store";

const ViewCustomerUploadDocumentsView: React.FC = () => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("md"));
  const formUserData: any = useSelector((state: RootState) => state.stepper.formData);
  const applicationNumber = useSelector(
    (state: RootState) => state.stepper.trackingId
  );
  const [enableCustomerJourney, setEnableCustomerJourney] = useState<boolean>(false);
  const [courseName, setCourseName] = useState<string | undefined>(undefined);
  const breadcrumbItems = isXsOrSm
    ? [
        {
          label: `${formUserData.courseName || ""} [#${applicationNumber || ""}]`,
          path: "",
        },
        { label: "Customer Upload Documents" },
      ]
    : [
        {
          label: `[#${applicationNumber || ""}]`,
          path: "",
        },
        { label: "Customer Upload Documents" },
      ];

  return (
    <>
      <Grid item xs={12} mb={2}>
        <Breadcrumbs items={breadcrumbItems} />
      </Grid>
      <Summary
        setEnableCustomerJourney={setEnableCustomerJourney}
        enableCustomerJourney={enableCustomerJourney}
        courseName={courseName}
        setCourseName={(value: string) => setCourseName(value)}
        hideHeaderActions={true}
      />
    </>
  );
};

export default ViewCustomerUploadDocumentsView;
